import { render } from "./ResourceSection.vue?vue&type=template&id=5d562378&scoped=true"
import script from "./ResourceSection.vue?vue&type=script&lang=js"
export * from "./ResourceSection.vue?vue&type=script&lang=js"

import "./ResourceSection.vue?vue&type=style&index=0&id=5d562378&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d562378"]])

export default __exports__